import React, { useCallback } from "react";
import { IComponentProps, SirenEntityBuilder, ISirenAction, IExtractedProps } from "../../common/utils/commonTypes";
import webui from "@tinqin/tinqin-web-ui";
import { getAddressFromActions } from "../../common/actions/page/PageAddress";
import "@tinqin/design-uneo-site-cp/less/common/search-dropdown.less";
import { xssFilter } from "Common/utils/xssFilter";
const { getEntityValue } = webui.getActionByName("utils");

interface IAutoSuggestListItems extends IComponentProps {
    predictions: SirenEntityBuilder[];
    parentClassifier: string,
    onSelectSuggestion: React.MouseEventHandler<HTMLLIElement>;
}

const AutoSuggestListItems: React.FC<IAutoSuggestListItems> = props => {
    const clickHandler = useCallback(
        (e: React.MouseEvent<HTMLLIElement, MouseEvent>, actions: ISirenAction[], entityId: string) => {
            props.onSelectSuggestion(e);
            const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
                additionalProps: ["value"],
            });
            const newProps: IComponentProps = Object.assign({}, props);
            if (newProps.config?.actions.length) {
                newProps.config.actions.forEach((action: ISirenAction) => {
                    if (action.properties?.action) action.properties.value = dataProps.value;
                });
            }
            const computedBindTo = `${props.computedBindTo}.${props.parentClassifier}.${entityId}`;
            webui.getUtils().dispatchSirenActions({ ...newProps, computedBindTo }, ["default", "click"], {
                actions
            });
        },
        [props]
    );
    const dispatch = webui.getDispatchMethod();
    const markKeyword = useCallback(
        (text: string) => {
            const keyword = dispatch(getEntityValue(props.computedBindTo));
            if (keyword.length) {
                const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escapedKeyword, "gi");
                return text.replace(regex, match => `<mark>${match}</mark>`);
            }
            return text;
        },
        [props, dispatch]
    );

    const list = props.predictions.map((entity, index) => {
        const id = entity.getId();
        const type = entity.getProperty("type");
        const title = entity.getChild("title").getValue();
        const subtitle = entity.getChild("subtitle").getValue();
        const content = entity.getChild("content").getValue();
        const actions = entity.getActions();
        return (
            <li
                key={`option-${id}`}
                tabIndex={index}
                data-value={entity.getLabel()}
                onClick={(e) => clickHandler(e, actions, id)}
            >
                <div className={`un-search-result-${type}`}>
                    <a
                        href={getAddressFromActions(actions)}
                        onClick={e => e.preventDefault()}
                    >
                        {title && (
                            <span
                                className="un-search-title"
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(markKeyword(title))
                                }}
                            />
                        )}
                        {subtitle && (
                            <span
                                className="un-search-subtitle"
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(markKeyword(subtitle))
                                }}
                            />
                        )}
                        {content && (
                            <span
                                className="un-search-content"
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(markKeyword(content))
                                }}
                            />
                        )}
                    </a>
                </div>
            </li>
        );
    });
    return <>{list}</>;
};

export default webui.connectComponent()(AutoSuggestListItems);
